export default "__VITE_ASSET__CQBSkVlV__"